/**
 * Manage list of streams
 */
export default class MediaStreamCache {
    /**
     * Creates instance of MediaStreamCache
     */
    constructor() {
        this.streams = [];
    }

    /**
     * Get previosly recieved stream
     * @param{Object.<{
     *   video: Object.<Device>,
     *   audio: Object.<Device>
     * }>} devices is list of devices which were used to receive the stream
     * @return {MediaStream}
     */
    getStream(devices) {
        return this[MediaStreamCache.getDevicesId(devices)];
    }

    /**
     * Get previosly recieved streams
     * @return {Array.<MediaStream>}
     */
    getStreams() {
        const result = [];
        this.streams.forEach((id) => {
            result.push(this[id]);
        });
        return result;
    }

    /**
     * adds stream to a cache
     * @param{Object.<{
     *   video: Object.<Device>,
     *   audio: Object.<Device>
     * }>} devices is object of devices which was used to receive the stream
     * @param{MediaStream} stream is recieved stream for the devices
     * @return {Promise<boolean>}
     */
    putStream(devices, stream) {
        const id = MediaStreamCache.getDevicesId(devices);
        this[id] = stream;
        this.streams.push(id);
        this.currentVideoOutput = null;
    }

    /**
     * remove previously stored stream
     * @param{Object.<{
     *   video: Object.<Device>,
     *   audio: Object.<Device>
     * }>} devices is list of devices which were used to receive the stream
     * @return {void}
     */
    removeStream(devices) {
        const id = MediaStreamCache.getDevicesId(devices);
        if (this[id]) {
            delete this[id];
            this.streams = this.streams.filter(i => i !== id);
        }
    }

    /**
     * returns generated id for provided devices
     * @param{Object.<{
     *   video: Object.<Device>,
     *   audio: Object.<Device>
     * }>} devices is object which was used to receive the stream
     * @return {string}
     */
    static getDevicesId(devices) {
        return `${((devices || {}).video || {}).id}__${((devices || {}).audio || {}).id}`;
    }

    /**
     * close all streams and remove them
     * @return{void}
     */
    cleanAll() {
        this.streams.forEach((id) => {
            if (this[id]) {
                delete this[id];
            }
        });
        this.stream = [];
    }
}
